import React from 'react';
import { ReactSVG } from 'react-svg';
import { observer } from 'mobx-react-lite';

import logo from 'assets/img/icons/white-logo.svg';

import { IMenuItem, IMenuLink } from '..';
import { NavigationLink } from '../../NavigationLink';

type Props = {
    onClickLogo: () => void,
    menuItems: IMenuItem[],
    menuLinks: IMenuLink[],
    isActive: boolean,
};

export const DefaultMenu = observer(({
    menuItems,
    menuLinks,
    isActive,
    onClickLogo,
}: Props) => {
    return (
        <div className={`side-menu ${isActive ? 'active' : ''}`}>
            <div className="top-wrapper">
                <div className="side-menu__logo" onClick={onClickLogo}>
                    <ReactSVG src={logo} />
                </div>

                <nav className="side-menu__navigation">
                    {menuLinks.map((item, index) => (
                        <NavigationLink
                            to={item.link}
                            key={`${index}__side-menu-item`}
                            className="side-menu__nav-item"
                        >
                            <ReactSVG className="side-menu__nav-icon" src={item.icon}/>
                            <span className="p2-medium">{item.title}</span>
                        </NavigationLink>
                    ))}
                </nav>
            </div>


            <div className="bottom-wrapper">
                {menuItems.map((item) => (
                    <div
                        key={`${item.title}__side-item`}
                        className="side-item"
                        onClick={item.onClick}
                    >
                        <ReactSVG
                            className="side-item__icon"
                            src={item.icon}
                        />
                        <span className="side-item__desc p2-medium">{item.title}</span>
                    </div>
                ))}
            </div>
        </div>
    );
});
